import XEUtils from 'xe-utils';
import PROJECTAPI from '@/api/park/project';
import { formatDate } from '@/utils';
export default {
  data() {
    return {
      projectNatureName: '',
      attachments: [],
    };
  },
  methods: {
    //反填数据
    async initDetail() {
      console.log('request', this.$route.query?.projectCode, this.$route.query?.pageMode);
      let origin = this.$route.query?.origin;
      let projectCode = this.$route.query?.projectCode;
      if (this.pageMode == 1) {
        //拉取详情数据
        var copyFlag = null;
        if (origin == 'copy') {
          copyFlag = '1';
        }
        if (projectCode) {
          this.loading.startLoading();
          const data = await this.getDetail(projectCode);
          console.log(data, 121212);
          this.isProjectNatureName(data.projectNature);
          console.log(this.projectNatureName, 3434);
          this.filterFormField(this.projectNatureName);
          this.loading.endLoading();
          Object.keys(data).forEach((key) => {
            let value = data[key];
            if (value == undefined || value == null) {
              value = '';
            }
            this.baseInfoData[key] = value;
          });
          if (copyFlag == '1') {
            //清空部分数据
            this.pageMode = 0;
            // this.baseInfoData.applyDepartmentName=null;
            // this.baseInfoData.projectName = null;
            // 在列表中显示，不在列表中清空
            this.departmentList.forEach((item) => {
              if (item.value == this.baseInfoData.applyDepartmentNo) {
                this.baseInfoData.applyDepartmentNo = item.value;
                this.baseInfoData.applyDepartmentName = item.label;
                return;
              } else {
                this.baseInfoData.applyDepartmentNo = null;
                this.baseInfoData.applyDepartmentName = null;
              }
            });
            console.log('this.departmentList', this.departmentList);
            this.baseInfoData.projectCode = null;
            // this.baseInfoData.bidOpeningDate = null;
            // this.baseInfoData.bidClosingDate = null;
            this.baseInfoData.applyDate = null;
            // this.baseInfoData.bidTotalAmount = 0;
            // this.baseInfoData.projectStartDate = null;
            // this.baseInfoData.projectEndDate = null;
            this.baseInfoData.projectStatus = null;
            this.baseInfoData.lastModifiedBy = null;
            this.baseInfoData.createBy = null;
            this.baseInfoData.projectStatusName = null;
            if (this.baseInfoData.serviceTypeCode == 'JG') {
              this.hideCustomerTypeOne = false;
            }
            if (this.baseInfoData.serviceTypeCode == 'CC') {
              this.hideCustomerTypeOne = true;
            }
          }
          this.wmProjectCargos = data['wmProjectCargos'];
          this.attachments = data['attachmentVOS'];
          // this.assignTypes();
        }
        //要处理baseinfo,cargos,routes,servicequotations
        //fixme
      }
      if (origin != 'detail') {
        //新增和复制
        this.baseInfoData.createByName = this.userInfo.userName;
        this.baseInfoData.lastModifiedByName = this.userInfo.userName;
        this.baseInfoData.gmtCreate = formatDate(new Date());
        this.baseInfoData.gmtModified = formatDate(new Date());
        this.baseInfoData.applyDate = formatDate(new Date());
      }
      let statusName = this.getStatusName(this.baseInfoData.projectStatus);
      console.log(statusName, 'statusName');
      // this.getProcessedBaseColumns(statusName, origin);
      console.log('baseInfoData', this.baseInfoData);
    },

    isProjectNatureName(projectNature) {
      if (projectNature == '双方' || projectNature == 'PIBT10') {
        this.projectNatureName = 'PIBT10';
      } else if (projectNature == '三方' || projectNature == 'PIBT11') {
        this.projectNatureName = 'PIBT11';
      } else if (projectNature == '四方' || projectNature == 'PIBT12') {
        this.projectNatureName = 'PIBT12';
      }
    },
    //双击行传的id查询数据
    async getDetail(projectCode) {
      let params = {};
      // if (copyFlag) {
      //   params.copyFlag = copyFlag;
      // }
      params.projectCode = projectCode;
      var res = await this.$axios.post(PROJECTAPI.DETAIL, params);
      // console.log(res,121212);
      if (res.data.code === 0) {
        return res.data.data || {};
      }
      return {};
    },
    async getData(params = {}) {
      var res = await this.$axios.post(PROJECTAPI.LIST_PROJECT, params);
      console.log(res, 88888888);
      if (res.data.code === 0) {
        let data = res.data.data || [];
        return data;
      }
      return null;
    },
    validateSearch() {
      let count = Object.keys(this.queryData).length;
      for (var key in this.queryData) {
        let value = this.queryData[key];
        if (value == null || value == undefined || value == [] || value == '') {
          count--;
        }
      }
      if (count == 0) {
        this.$message({
          showClose: true,
          message: this.$t('search.nosearchError'),
          type: 'error',
        });
        return false;
      }
      return true;
    },
    formatDateCustom(date) {
      if (!date || !date.length) {
        return null;
      }
      return XEUtils.toDateString(date, 'yyyy-MM-dd HH:mm:ss');
    },
    async revoke(projectCode, invalidReason, remarks) {
      let params = { projectCode: projectCode, invalidReason: invalidReason, remarks: remarks };
      console.log(params, 'revoke');
      // this.loading.startLoading()
      this.loading = true;
      const { data } = await this.$axios.post(PROJECTAPI.DISCARD, params);
      console.log(data, 'revoke1212');
      this.loading = false;
      if (data.code == 0) {
        this.$message.success(data.msg);
        // this.$router.push({ path: '/park/warehouse/projectList' });
      } else {
        this.$message.error(data.msg);
      }
    },
    _convert(contractType, projectCode, projectName) {
      console.log(contractType, projectCode, projectName);
      if (contractType == 'CC') {
        let name = contractType == 'CC' ? '合同维护' : '监管合同维护';
        let query = {};
        if (projectCode) {
          query.projectCode = projectCode;
          query.pageMode = 0;
        }
        let path = {
          path: '/park/warehouse/contractMaintainance',
          name: 'contractMaintainance',
          meta: {
            keepAlive: true,
            title: name,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      } else {
        let name = contractType == 'CC' ? '仓储合同维护' : '监管合同维护';
        let query = {};
        if (projectCode) {
          query.projectCode = projectCode;
          query.projectName = projectName;
          query.status = 'create';
        }
        let path = {
          path: '/park/superviseContract/detail',
          name: 'detail',
          meta: {
            keepAlive: true,
            title: name,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      }
    },
    //type 0保存1提交,审批通过会调用宁外一个接口
    async save(baseData, wmProjectCargos, type = 0, getProjectStatusName, origin) {
      console.log(getProjectStatusName, 'getProjectStatusName');
      // 保存不校验必填
      if (type == 1) {
        await this.$refs.baseInfoFormRef.getValidateFormData();
      }
      // if (type == 0) {
      //   let message = '';
      //   if (!wmProjectCargos || !wmProjectCargos.length) {
      //     message = '请创建至少一条货物信息!';
      //   }
      //   if (message.length > 1) {
      //     this.$message({
      //       showClose: true,
      //       message: message,
      //       type: 'error',
      //     });
      //     return;
      //   }
      // }
      if (type == 1) {
        let message = '';
        if (!wmProjectCargos || !wmProjectCargos.length) {
          message = '请创建至少一条货物信息!';
        }
        let attachmentsValid = this.$refs.fileTableRef.getTableData();
        if (['JG'].includes(baseData.serviceTypeCode)) {
          if (!attachmentsValid || !attachmentsValid.length) {
            message = '请上传至少一个附件!';
          }
        }

        if (message.length > 1) {
          this.$message({
            showClose: true,
            message: message,
            type: 'error',
          });
          return;
        }
      }
      let params = baseData;
      params.oaId = this.userInfo.oaId;
      params.wmProjectCargos = wmProjectCargos;
      params.type = type;
      params.applyDate = this.formatDateCustom(params.applyDate);
      params.bidOpeningDate = this.formatDateCustom(params.bidOpeningDate);
      params.bidClosingDate = this.formatDateCustom(params.bidClosingDate);
      params.projectStartDate = this.formatDateCustom(params.projectStartDate);
      params.projectEndDate = this.formatDateCustom(params.projectEndDate);
      params.gmtCreate = this.formatDateCustom(params.gmtCreate);
      params.gmtModified = this.formatDateCustom(params.gmtModified);
      params.attachments = this.$refs.fileTableRef.getTableData();
      // 添加公司
      params.companyName = this.userInfo.companyName;
      delete params.attachmentVOS;
      console.log(params, 121212);
      if (getProjectStatusName == '审批通过') {
        let params1 = params;
        delete params1.id;
        params1.wmProjectCargos.forEach((item) => {
          delete item.id;
        });
        console.log(params1, 'params1');
        this.loading.startLoading();
        const { data } = await this.$axios.post(PROJECTAPI.INPASSEDIT, this.filterEmpty(params1));
        this.loading.endLoading();
        console.log(data, 123456);
        if (data.code == 0) {
          this.$message.success(data.msg);
          this.$router.push({ path: '/park/warehouse/projectList' });
          this.handleSwitchEditMode();
        } else {
          this.$message.error(data.msg);
        }
      } else {
        if (origin == 'copy') {
          let params2 = params;
          delete params2.id;
          params2.wmProjectCargos.forEach((item) => {
            delete item.id;
          });
          console.log(params2, 'params2');
          this.loading.startLoading();
          const { data } = await this.$axios.post(PROJECTAPI.SAVEOREDIT, this.filterEmpty(params2));
          console.log(data, 123456);
          this.loading.endLoading();
          if (data.code == 0) {
            this.$message.success(data.msg);
            this.$router.push({ path: '/park/warehouse/projectList' });
            this.handleSwitchEditMode();
          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.loading.startLoading();
          const { data } = await this.$axios.post(PROJECTAPI.SAVEOREDIT, this.filterEmpty(params));
          console.log(data, 123456);
          this.loading.endLoading();
          if (data.code == 0) {
            this.$message.success(data.msg);
            this.$router.push({ path: '/park/warehouse/projectList' });
            this.handleSwitchEditMode();
          } else {
            this.$message.error(data.msg);
          }
        }
      }
      // this.handleSwitchEditMode();
    },
  },
  mounted() {},
};
